// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"d5ca94fd","445":"6029c33a","661":"68331e2e"}[chunkId] + ".chunk.js";
};